module.exports = __webpack_public_path__ + "media/images/partners/snfi-64d1064f3cd4fcdabbc482c5c2a86d82.png";